import React from "react";
import { Link, useLocation } from "react-router-dom";
import useStickyNavbar from "../hooks/useStickyNavbar";

function Navbar() {
  useStickyNavbar();
  const { pathname } = useLocation();

  const handleNavLinkClick = () => {
    // Close mobile menu when a navigation link is clicked
    // Use multiple approaches to ensure it works reliably
    const navbarCollapse = document.querySelector('#navbar-mobile');
    const toggleButton = document.querySelector('[data-target="#navbar-mobile"]');
    
    if (navbarCollapse && toggleButton) {
      // Check if menu is open (has 'in' class)
      if (navbarCollapse.classList.contains('in')) {
        // Method 1: Trigger click on toggle button
        toggleButton.click();
        
        // Method 2: Remove 'in' class directly if needed
        setTimeout(() => {
          if (navbarCollapse.classList.contains('in')) {
            navbarCollapse.classList.remove('in');
            navbarCollapse.style.height = '';
          }
        }, 100);
      }
    }
  };

  return (
    <header id="top" className="header-inner">
      <div className="brand-panel">
        <Link
          to="#top"
          className="brand js-target-scroll"
          style={{ display: "block", padding: "20px 0" }}
        >
          <img
            src="img/img-icon/logo_xinchuan.svg"
            alt="XIN CHUAN Logo"
            style={{ height: "80px", maxWidth: "100%" }}
          />
        </Link>
        <div className="brand-name">XIN CHUAN</div>
        {pathname === "/" && (
          <div className="slide-number">
            <span className="current-number text-primary">
              0<span className="count">1</span>
            </span>
            <sup>
              <span className="delimiter">/</span> 0
              <span className="total-count"></span>
            </sup>
          </div>
        )}
      </div>

      <div className="header-phone">+60(19) 578-0801<br />+60(7) 597-0720</div>

      <div className="vertical-panel-content">
        <div className="vertical-panel-info">
          <div className="line"></div>
        </div>
        <ul className="social-list">
          {/* <li>
            <a
              href="https://www.instagram.com/p/DDMcH5_yRrx/"
              className="fa fa-instagram"
            ></a>
          </li> */}
          <li>
            <a 
              href="https://www.xiaohongshu.com/user/profile/656025030000000002035697?xsec_token=YBfhoGtbauhu73WhcmyzwiEump9Ygo8m6sVxhzPhq57os%3D&xsec_source=app_share&xhsshare=CopyLink&appuid=656025030000000002035697&apptime=1750327179&share_id=45cb226af9054780ba104517826e950f&share_channel=copy_link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img 
                src="img/img-icon/red note logo 2.png" 
                alt="Xiaohongshu"
                style={{ width: "38px", height: "38px" }}
              />
            </a>
          </li>
          <li>
            <a href="https://wa.me/60195780801" className="fa fa-whatsapp"></a>
          </li>
          <li>
            <a
              href="https://www.facebook.com/share/1ATuW4rMbL/"
              className="fa fa-facebook"
              target="_blank"
              rel="noopener noreferrer"
            ></a>
          </li>
        </ul>
      </div>

      <nav className="navbar-desctop visible-md visible-lg">
        <div className="container">
          <Link to="#top" className="brand js-target-scroll">
            <img
              src="img/img-icon/logo_xinchuan.svg"
              alt="XIN CHUAN Logo"
              style={{ height: "35px", maxWidth: "100%" }}
            />
          </Link>
          <ul className="navbar-desctop-menu">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About us</Link>
            </li>
            <li>
              <Link to="/projects">Projects</Link>
            </li>
            <li>
              <Link to="/designer">Designer</Link>
            </li>
            <li>
              <Link to="/furnitures">Furnitures</Link>
            </li>
            <li>
              <Link to="/contacts">Contacts</Link>
            </li>
          </ul>
        </div>
      </nav>

      <nav className="navbar-mobile">
        <Link to="#top" className="brand js-target-scroll">
          <img
            src="img/img-icon/logo_xinchuan.svg"
            alt="XIN CHUAN Logo"
            style={{ height: "35px", maxWidth: "100%" }}
          />
        </Link>
        <button
          type="button"
          className="navbar-toggle collapsed"
          data-toggle="collapse"
          data-target="#navbar-mobile"
        >
          <span className="sr-only">Toggle navigation</span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbar-mobile">
          <ul className="navbar-nav-mobile">
            <li className={pathname === "/" ? "active" : ""}>
              <Link to="/" onClick={handleNavLinkClick}>Home</Link>
            </li>
            <li className={pathname === "/about" ? "active" : ""}>
              <Link to="/about" onClick={handleNavLinkClick}>About us</Link>
            </li>
            <li className={pathname === "/projects" ? "active" : ""}>
              <Link to="/projects" onClick={handleNavLinkClick}>Projects</Link>
            </li>
            <li className={pathname === "/designer" ? "active" : ""}>
              <Link to="/designer" onClick={handleNavLinkClick}>Designer</Link>
            </li>
            <li className={pathname === "/furnitures" ? "active" : ""}>
              <Link to="/furnitures" onClick={handleNavLinkClick}>Furnitures</Link>
            </li>
            <li className={pathname === "/contacts" ? "active" : ""}>
              <Link to="/contacts" onClick={handleNavLinkClick}>Contacts</Link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
